<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false, labels: { font: { family: fontFamily } } },
    tooltip: {
      titleFont: { family: fontFamily },
      bodyFont: { family: fontFamily },
    },
  },
  animation: { duration: 0 },
  elements: {
    line: { tension: 0.3, borderWidth: 2 },
    point: { radius: 2, hoverRadius: 4 },
  },
  scales: {
    x: {
      ticks: {
        font: { family: fontFamily },
        maxRotation: 0,
        autoSkip: true,
        maxTicksLimit: 8,
      },
      grid: { drawOnChartArea: false },
    },
    y: {
      type: 'linear',
      position: 'left',
      beginAtZero: true,
      ticks: { font: { family: fontFamily }, precision: 0 },
      grid: { drawOnChartArea: false },
    },
  },
};

const options = computed(() => ({
  ...defaultChartOptions,
  ...props.chartOptions,
}));
</script>

<template>
  <Line :data="collection" :options="options" />
</template>
